module.exports = __webpack_public_path__ + "media/img/home/clients-map/map4-99327d0441daed9197e737ca6d5bcf8f.png";